module.exports = __webpack_public_path__ + "static/img/logo_2.abc7053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_2.png
// module id = a/7e
// module chunks = 1